import {
    SHOW_MODAL,
    HIDE_MODAL
  } from './types'
  
  export const showModal = (params) => {
    return {
      type: SHOW_MODAL,
      payload: params
    }
  };
  
  export const hideModal = () => {
    return {
      type: HIDE_MODAL
    }
  };
  